import { Tag } from '@components';
import React, { FC, ReactNode } from 'react';
import { Calendar, Clock } from 'react-feather';

type DateType = {
  date: string;
  icon?: boolean;
  time?: boolean;
  noDate?: ReactNode; // ✅ nu flexibel
};

export const DateFormatted: FC<DateType> = ({ date, icon, time, noDate }) => {
  if (!date) return <span>-</span>;

  const dt = new Date(date);

  if (isNaN(dt.getTime())) {
    return <span>-</span>;
  }

  // Format date
  const dateFormatted = dt.toLocaleDateString('nl-BE', {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  const timeFormatted = time
    ? dt.toLocaleTimeString('nl-BE', {
        hour: '2-digit',
        minute: '2-digit',
      })
    : '';

  const label = (
    <span className="flex gap-x-2 items-center">
      {icon && (
        <span className="flex items-center gap-x-1">
          <Calendar size={14} /> {dateFormatted}
        </span>
      )}

      {time && icon && (
        <span className="flex items-center gap-x-1">
          <Clock size={14} /> {timeFormatted}
        </span>
      )}

      {!icon && (
        <span>
          {dateFormatted} {time && timeFormatted}
        </span>
      )}
    </span>
  );

  return <Tag label={label} style="neutral" lowercase={1} />;
};

export default DateFormatted;
